import React, { Component } from 'react'
import Button from '../Button'
import Modal from './Modal'

export const title = '基本'

export const description = '第一个对话框'

export class Demo extends Component {
  state = {
    showModal: false,
  }
  render() {
    const { showModal } = this.state
    return (
      <>
        <Button data-testid="defaultModal" onClick={this.toggleModal}>
          显示对话框标题
        </Button>
        <Modal
          visible={showModal}
          title="默认对话框"
          onOk={this.toggleModal}
          onCancel={this.toggleModal}
        >
          <div>对话框的内容</div>
          <div>对话框的内容</div>
          <div>对话框的内容</div>
        </Modal>
      </>
    )
  }

  toggleModal = () => {
    this.setState(state => ({ showModal: !state.showModal }))
  }
}

export const example = `class Demo extends Component {
  state = {
    showModal: false,
  }
  render() {
    const { showModal } = this.state
    return (
      <>
        <Button data-testid="defaultModal" onClick={this.toggleModal}>
          显示默认对话框
        </Button>
        <Modal
          visible={showModal}
          title="默认对话框"
          onOk={this.toggleModal}
          onCancel={this.toggleModal}
        >
          <div>对话框的内容</div>
          <div>对话框的内容</div>
          <div>对话框的内容</div>
        </Modal>
      </>
    )
  }

  toggleModal = () => {
    this.setState(state => ({ showModal: !state.showModal }))
  }
}`
